/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DashboardSeriesPointDto } from './dashboardSeriesPointDto';
import { DashboardActivityDto } from './dashboardActivityDto';


export interface ConsoleDashboardDto { 
    revenue?: number;
    revenueDeltaPct?: number;
    transactionCount?: number;
    transactionCountDeltaPct?: number;
    pointsAwarded?: number;
    pointsAwardedDeltaPct?: number;
    couponsRedeemed?: number;
    couponsRedeemedDeltaPct?: number;
    pendingCount?: number;
    series?: Array<DashboardSeriesPointDto>;
    activity?: Array<DashboardActivityDto>;
}

